import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=681d26ba&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681d26ba')) {
      api.createRecord('681d26ba', component.options)
    } else {
      api.reload('681d26ba', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=681d26ba&", function () {
      api.rerender('681d26ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YTllu34z80my/JS/pricehelp.vue"
export default component.exports